'use client';
import { ConnectButton as RainbowConnectButton } from '@rainbow-me/rainbowkit';
import ActionButton, {
  ActionButtonProps,
} from '@/components/elements/ActionButton/ActionButton';
import { useTranslations } from 'use-intl';
import { ReactNode } from 'react';
import ConnectButton from './ConnectButton';
import Skeleton from '@/presentation/components/ui/Skeleton/Skeleton';

const ConnectWrapper = ({
  children,
  mounted,
}: {
  children: ReactNode;
  mounted: boolean;
}) => {
  if (mounted) {
    return <div>{children}</div>;
  }
  return <Skeleton className="h-12 w-[150px] rounded-none" />;
};

const ConnectButtonContainer = ({
  children,
  ...props
}: Partial<Pick<ActionButtonProps, 'blendColor' | 'className'>> & {
  children?: ReactNode;
}) => {
  const t = useTranslations('Connect');

  return (
    <RainbowConnectButton.Custom>
      {({
        account,
        chain,
        openAccountModal,
        openChainModal,
        openConnectModal,
        mounted,
      }) => {
        return (
          <ConnectWrapper mounted={mounted}>
            <ConnectButton
              account={account}
              chain={chain}
              mounted={mounted}
              openAccountModal={openAccountModal}
              openChainModal={openChainModal}
              openConnectModal={openConnectModal}
              {...props}
            >
              {children}
            </ConnectButton>
          </ConnectWrapper>
        );
      }}
    </RainbowConnectButton.Custom>
  );
};

export default ConnectButtonContainer;
